import { render, staticRenderFns } from "./SetupStart.vue?vue&type=template&id=66402f14&scoped=true"
import script from "./SetupStart.vue?vue&type=script&lang=js"
export * from "./SetupStart.vue?vue&type=script&lang=js"
import style0 from "./SetupStart.vue?vue&type=style&index=0&id=66402f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66402f14",
  null
  
)

export default component.exports